export default class DeleteWorkScopeSpecificationError extends Error {
    
}